import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { initLenis, destroyLenis } from "./lib/scroll";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import LatestProject from "./components/LatestProject";
import MoneyTalks from "./components/MoneyTalks";
import Marquee from "./components/Marquee";
import CaseFiles from "./components/CaseFiles";
import Closing from "./components/Closing";
import CaseStudy from "./components/CaseStudy";
import SliceJoint from "./components/SliceJoint";
import WingPong from "./components/WingPong";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    componentDidCatch(err) {
        console.error(err);
    }
    render() {
        if (this.state.hasError) {
            return (
                <div className="flex min-h-screen items-center justify-center bg-black font-mono text-xs uppercase tracking-[0.2em] text-white">
                    Money Mac Media — technical difficulties. The money is fine.
                </div>
            );
        }
        return this.props.children;
    }
}

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
}

function Home() {
    return (
        <main>
            <Hero />
            <LatestProject />
            <MoneyTalks />
            <Marquee />
            <CaseFiles />
            <Closing />
        </main>
    );
}

export default function App() {
    useEffect(() => {
        initLenis();
        return () => destroyLenis();
    }, []);

    return (
        <ErrorBoundary>
            <BrowserRouter>
                <ScrollToTop />
                <div className="bg-black text-white antialiased">
                    <Nav />
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/work/hot-ones-game-night" element={<CaseStudy />} />
                        <Route path="/work/slice-joint" element={<SliceJoint />} />
                        <Route path="/work/hot-ones-wing-pong" element={<WingPong />} />
                        <Route path="*" element={<Home />} />
                    </Routes>
                    <div className="grain" aria-hidden="true" />
                </div>
            </BrowserRouter>
        </ErrorBoundary>
    );
}
